export const OPEN_MODAL_SEND_EMAIL = "OPEN_MODAL_SEND_EMAIL";
export const OPEN_MODAL_SEND_EMAIL_ID = "OPEN_MODAL_SEND_EMAIL_ID";
export const OPEN_MODAL_SEND_EMAIL_USER = "OPEN_MODAL_SEND_EMAIL_USER";
export const CLOSE_MODAL_SEND_EMAIL = "CLOSE_MODAL_SEND_EMAIL";
export const SEND_EMAIL = "SEND_EMAIL";
